export default function Earnings() {
    return <h1>Earnings Page</h1>
}